import "leaflet";
import "leaflet-tilelayer-here";
document.addEventListener("turbo:load", () => {
  $("[data-decidim-map]").on("configure.decidim", (_ev, map, mapConfig) => {
    L.tileLayer.here(mapConfig.tileLayer).addTo(map);
  });
});
